import CastConnected from '@mui/icons-material/CastConnected';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CastConnectedIcon(props: FixMe) {
  return <CastConnected {...props} />;
}

export default CastConnectedIcon;
